import { Typography } from '@mui/material';
import { Row } from '.';
import { type JSX } from 'react';

interface AdminPageProps extends React.PropsWithChildren {
  title?: string;
  showAdornment?: boolean | undefined;
  titleAdornment?: JSX.Element;
  style?: React.CSSProperties;
}

const Page: React.FC<AdminPageProps> = props => {
  return (
    <div style={{ margin: '30px 40px', ...props.style }}>
      <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        {props.title && (
          <Typography
            variant='p40'
            color='secondary.main'
            flexGrow={1}
            whiteSpace='nowrap'
            overflow='hidden'
            textOverflow='ellipsis'>
            {props.title}
          </Typography>
        )}
        {props.showAdornment && props.titleAdornment}
      </Row>
      {props.children}
    </div>
  );
};

export default Page;
